import React from "react";

export function Section(props: {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  children?: React.ReactNode;
}) {
  return (
    <>
      <div
        className="title is-5 has-text-centered"
        style={{ marginBottom: props.subtitle ? "0.2em" : undefined }}
      >
        {props.title}
      </div>
      {props.subtitle && (
        <div
          className="is-6 has-text-centered"
          style={{ marginBottom: "0.5em" }}
        >
          {props.subtitle}
        </div>
      )}
      {props.children}
    </>
  );
}
